<template>
    <div>
      <nav-breadcrumb :menu="[{label: '产品列表'}]"/>
      <div class="xzpadd10 bg-purple">
        <data-table
          :tableData="listData"
          :columns="listColumns"
          :filters="filters"
          :pageSize.sync="pageSize"
          :page.sync="page"
          :actions="actions"
        ></data-table>
      </div>
    </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import {removeItem, xmlBuildQuery} from "../../../filters/CommonActions";
  import Status2CN from "../../../filters/Status2CN";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    data() {
      return {
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '产品编号',
            field: 'p__productCode'
          },
          {
            name: '产品名称',
            field: 'p__productName'
          },
          // {
          //   name: '期限（天）',
          //   field: 'p__validityPeriod'
          // },
          {
            name: '额度(元)',
            field: 'p__creditCap',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '期限（月）',
            field: 'p__repaymentCount'
          },
          // {
          //   name: '利率',
          //   field: 'p__interestRate',
          //   formatter: function (r,c,v) {
          //     return v +'% (' +  Status2CN(r.p__interestType)+')'
          //   }
          // },
          // {
          //   name: '服务费',
          //   field: 'p__lendingFee',
          //   formatter: function (r,c,v) {
          //     return formatMoney(v) + (r.p__lendingFeeType == 'Rate' ? '%' : '元')
          //   }
          // },
          {
            name: '创建时间',
            field: 'p__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            name: '操作',
            opts:
              [
                {
                  clickHandler: (index,row)=>{
                    this.editProduct(index, row)
                  },
                  class: 'el-icon-edit',
                  name: '编辑产品'
                },
                {
                  clickHandler: (index, row)=>{
                    this.removeItem(index, row)
                  },
                  class: 'el-icon-delete',
                  name: '删除产品'
                },
              ]

          }
        ],
        filters: {
          form: {
            'p__productName' : '',
            'p__createdDate' : [],
          },
          columns: [
            {
              label: '产品名称',
              component: 'el-input',
              field: 'p__productName',
              op: 'like'
            },
            {
              label: '创建日期',
              component: 'date-range-picker',
              field: 'p__createdDate',
              op: ['gteq', 'lteq']
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getFinanceProductList()
          }
        },
        actions: [
          {
            label: '新增产品',
            type: 'primary',
            clickHandler:()=>{
              this.$router.push({path: 'Edit'})
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function () {
          return Object.assign({
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.sort.dataField': 'p.createdDate',
              'xlist.sort.order': 'desc'
            },
            xmlBuildQuery(this.filters)
          )
        },
        set: function (newVal) {

        }
      }
    },
    watch: {
      page: function () {
        this.getFinanceProductList()
      }
    },
    mounted() {
      this.getFinanceProductList()
    },
    components: {
      DataTable
    },
    methods: {
      getFinanceProductList: function () {
        xhr.getFinanceProductList(
          this.filterParams,
          res=> {
          try {
            if(res.data.status == 'success') {
              this.listData = res.data
            }
          }catch(e){

          }
        })

      },
      editProduct: function (index, row) {
        try{
          this.$router.push({
            'path': 'Edit?p.productId='+row.p__productId
          })
        }catch (e) {

        }
      },
      removeItem: function (index, row) {
        removeItem(
          xhr.deleteFinanceProduct,

          {
            'p.productId': row.p__productId
          },

          ()=>{
            this.getFinanceProductList()
          }
        )
      },

      onFilterSubmit: function () {
        this.page = 1
        this.getFinanceProductList()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ProductList.vue